import { isNative, openReturnableUrl } from '@core/platform';
import { useRuntimeBrand } from '@core/hooks/useRuntimeBrand';
import { useCopy } from '@/app/providers/useCopy';

// "Powered by <partner | PosBytz>" attribution. The name and link come from
// the store-resolve API (see pickResolvedPoweredBy).
export default function PoweredBy({ className = 'powered-by' }) {
  const t = useCopy();
  const { poweredBy } = useRuntimeBrand();
  if (!poweredBy?.name) return null;

  // Native WebViews don't honour target="_blank"; hand off to the in-app browser.
  const handleClick = (event) => {
    if (!isNative()) return;
    event.preventDefault();
    openReturnableUrl(poweredBy.url);
  };

  return (
    <span className={className}>
      {t('poweredBy', 'Powered by')}{' '}
      {poweredBy.url ? (
        <a href={poweredBy.url} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
          {poweredBy.name}
        </a>
      ) : (
        poweredBy.name
      )}
    </span>
  );
}
